import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useInsertTransferOperation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = (
    getTransferOperationList,
    setIsInsertModalOpen,
    setInsertLoading,
    payload,
  ) => {
    axiosClient
      .post(`Operation/Transfer/Insert`, {
        zoneGuid: payload.zoneGuid,
        title: payload.title,
        description: payload.description,
        voucherType: payload.voucherType,
        counterpartID: payload.counterpartID,
        voucherID: payload.voucherID,
        invoiceNumber: payload.invoiceNumber,
        storeID: payload.storeID,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          getTransferOperationList?.();
          setIsInsertModalOpen?.(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setInsertLoading?.(false));
  };

  return { insertRequest };
};

export default useInsertTransferOperation;
